<template>
  <section>
    <div v-for="input in inputs" :key="input.inputID">
      <NumberInput
        v-if="input.type === 'NUMBER'"
        @onUpdate="onInputChange"
        :inputID="input.inputID"
        :label="input.label"
        :max="input.max"
        :min="input.min"
        :required="input.required"
        :is-Disabled="isDisabled"
      />

      <TextInput
        v-if="input.type === 'TEXT'"
        @onUpdate="onInputChange"
        :inputID="input.inputID"
        :label="input.label"
        :maxLength="input.maxLength"
        :minLength="input.minLength"
        :required="input.required"
        :is-Disabled="isDisabled"
      />

      <SelectInput
        v-if="input.type === 'SELECT'"
        @onUpdate="onInputChange"
        :inputID="input.inputID"
        :label="input.label"
        :values="input.values"
        :is-Disabled="isDisabled"
      />

      <OtpInput
        v-if="input.type === 'OTP'"
        @onUpdate="onInputChange"
        :inputID="input.inputID"
        :label="input.label"
        :required="input.required"
        :length="inputLength(input.maxLength, input.minLength)"
        :is-Disabled="isDisabled"
      />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import NumberInput from "./NumberInput.vue";
import TextInput from "./TextInput.vue";
import SelectInput from "./SelectInput.vue";
import OtpInput from "./OtpInput.vue";
import { InputField } from "@/models/template";

export default defineComponent({
  name: "InputsComponent",
  components: { NumberInput, TextInput, SelectInput, OtpInput },

  data() {
    return {
      defaultInputLength: 4,
    };
  },

  setup() {
    const inputAnswers = new Map();
    return { inputAnswers };
  },

  props: {
    inputs: {
      required: true,
      type: Array as PropType<InputField[]>,
    },
    isDisabled: {
      type: Boolean,
    },
  },

  methods: {
    inputLength(inputMaxLength?: number, inputMinLength?: number): number {
      if (inputMaxLength) {
        return inputMaxLength;
      } else if (inputMinLength) {
        return inputMinLength;
      }
      return this.defaultInputLength;
    },

    onInputChange(id: string, value: string) {
      this.inputAnswers.set(id, value);
      this.$emit("inputUpdated", this.inputAnswers);
    },
  },
  emits: ["inputUpdated"],
});
</script>
